<template>
  <p
    class="title font-weight-light"
    style="line-height: 1.1 !important;"
  >
    <slot />
  </p>
</template>

<script>
  export default {
    name: 'BaseText',
  }
</script>
